import { makeStyles } from "@material-ui/styles";

export const useStyles = makeStyles(() => ({
  buttonStyle: (props) => ({
    width: props.width,
    height: props.height,
  }),
}));
